module.exports = __webpack_public_path__ + "static/media/case_01.8be588ac.jpg";